<div class="qdp-wrap">

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="qdp-preset-field">
    <mat-icon matPrefix>date_range</mat-icon>
    <mat-select
      [value]="selectedPreset()"
      [attr.aria-label]="'ADMIN.quickDatePicker.changeRangeTooltip' | translate"
      (selectionChange)="selectPreset($event.value)">
      @for (preset of presets; track preset.key) {
        <mat-option [value]="preset.key">{{ preset.labelKey | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (selectedPreset() === 'custom') {
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="qdp-date-field">
      <input
        matInput
        [matDatepicker]="pickerFrom"
        [placeholder]="'ADMIN.quickDatePicker.from' | translate"
        [attr.aria-label]="'ADMIN.quickDatePicker.from' | translate"
        (dateChange)="onCustomFromChange($event.value)" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="qdp-date-field">
      <input
        matInput
        [matDatepicker]="pickerTo"
        [placeholder]="'ADMIN.quickDatePicker.to' | translate"
        [attr.aria-label]="'ADMIN.quickDatePicker.to' | translate"
        (dateChange)="onCustomToChange($event.value)" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>
  }

</div>
